module.exports = "/_next/static/images/Hero-xs-e7493c105bf277ed4cb98de0876822d2.webp";